import { useWindowSize } from '@vueuse/core';

export function useScreenWidth() {
  const { width } = useWindowSize();

  return {
    screenSize: width,
  };
}
